import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

import { MigrationReport as MigrationReportComponent } from "@/components/migrationReport";
import { Loading } from "@/components/shared/Loading";
import { useAbilities } from "@/hooks/ability/hooks";

const MigrationReport = () => {
  const { cannot, isLoading } = useAbilities();
  const router = useNavigate();

  useEffect(() => {
    if (!isLoading && cannot("MAINTAINER")) {
      router({ to: "/" });
    }
  }, [cannot, isLoading, router]);

  return (
    <div>
      <Loading isLoading={isLoading}>
        <MigrationReportComponent />
      </Loading>
    </div>
  );
};

export const Route = createFileRoute("/migration-report/")({
  component: () => <MigrationReport />,
});
